import styled from '@mui/material/styles/styled'
import Box from './Box'

export const DiscountRegionBox = styled(Box)`
  background-color: rgb(243, 242, 242);
  border-radius: 12px;
`
